import React from 'react';
import { FiShare2, FiChevronDown, FiChevronUp, FiUser, FiSliders, FiArrowUp, FiArrowDown } from 'react-icons/fi';

const VeroeffentlichtePlaene = ({
  user,
  publishedPlans,
  loading,
  error,
  refresh,
  expandedPlans,
  setExpandedPlans,
  planVersions,
  setPlanVersions,
  loadingVersions,
  setLoadingVersions,
  onLoadFromDatabase,
  loadPlanVersions,
  togglePlanExpansion,
  currentLoadedPlanId,
  isInTab = false // Neue Prop
}) => {
  const [sortBy, setSortBy] = React.useState('date'); // 'date' oder 'name'
  const [sortOrder, setSortOrder] = React.useState('desc'); // 'asc' oder 'desc'
  const [showSortDropdown, setShowSortDropdown] = React.useState(false);

  // Sortiere die Pläne basierend auf aktuellen Einstellungen
  const sortedPlans = React.useMemo(() => {
    if (!publishedPlans || publishedPlans.length === 0) return [];
    
    const sorted = [...publishedPlans].sort((a, b) => {
      if (sortBy === 'name') {
        const comparison = a.name.localeCompare(b.name, 'de');
        return sortOrder === 'asc' ? comparison : -comparison;
      } else {
        const dateA = new Date(a.updated_at);
        const dateB = new Date(b.updated_at);
        return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
      }
    });
    
    return sorted;
  }, [publishedPlans, sortBy, sortOrder]);

  // Schließe Dropdown bei Klick außerhalb
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (showSortDropdown && !event.target.closest('.sort-dropdown-container')) {
        setShowSortDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showSortDropdown]);

  if (!user) return null;

  return (
    <div style={{ 
      padding: isInTab ? '12px' : '12px', 
      borderTop: isInTab ? 'none' : '1px solid #ddd', 
      marginTop: isInTab ? '0' : '16px',
      backgroundColor: isInTab ? 'transparent' : '#f0f8ff',
      position: 'relative',
      overflow: 'visible'
    }}>
      {!isInTab && (
        <h4 style={{ 
          margin: '0 0 12px 0', 
          fontSize: '16px',
          color: '#333',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <FiShare2 size={16} />
            Veröffentlichte Pläne
            
            {/* Sortier-Dropdown */}
            <div className="sort-dropdown-container" style={{ position: 'relative' }}>
              <button
                onClick={() => setShowSortDropdown(!showSortDropdown)}
                style={{
                  background: 'none',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  color: '#666',
                  cursor: 'pointer',
                  padding: '4px',
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: '12px',
                  backgroundColor: showSortDropdown ? '#f5f5f5' : 'transparent'
                }}
                title="Sortierung ändern"
              >
                <FiSliders size={12} />
              </button>
              
              {showSortDropdown && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  backgroundColor: 'white',
                  border: '1px solid #ddd',
                  borderRadius: '4px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                  zIndex: 10000,
                  minWidth: '180px',
                  marginTop: '2px'
                }}>
                  <button
                    onClick={() => {
                      setSortBy('name');
                      setSortOrder('asc');
                      setShowSortDropdown(false);
                    }}
                    style={{
                      width: '100%',
                      padding: '8px 12px',
                      border: 'none',
                      backgroundColor: sortBy === 'name' && sortOrder === 'asc' ? '#e3f2fd' : 'transparent',
                      color: '#333',
                      cursor: 'pointer',
                      fontSize: '12px',
                      textAlign: 'left',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      borderBottom: '1px solid #f0f0f0'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = sortBy === 'name' && sortOrder === 'asc' ? '#e3f2fd' : '#f5f5f5'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = sortBy === 'name' && sortOrder === 'asc' ? '#e3f2fd' : 'transparent'}
                  >
                    <FiArrowUp size={12} />
                    Name A → Z
                  </button>
                  
                  <button
                    onClick={() => {
                      setSortBy('name');
                      setSortOrder('desc');
                      setShowSortDropdown(false);
                    }}
                    style={{
                      width: '100%',
                      padding: '8px 12px',
                      border: 'none',
                      backgroundColor: sortBy === 'name' && sortOrder === 'desc' ? '#e3f2fd' : 'transparent',
                      color: '#333',
                      cursor: 'pointer',
                      fontSize: '12px',
                      textAlign: 'left',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      borderBottom: '1px solid #f0f0f0'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = sortBy === 'name' && sortOrder === 'desc' ? '#e3f2fd' : '#f5f5f5'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = sortBy === 'name' && sortOrder === 'desc' ? '#e3f2fd' : 'transparent'}
                  >
                    <FiArrowDown size={12} />
                    Name Z → A
                  </button>
                  
                  <button
                    onClick={() => {
                      setSortBy('date');
                      setSortOrder('desc');
                      setShowSortDropdown(false);
                    }}
                    style={{
                      width: '100%',
                      padding: '8px 12px',
                      border: 'none',
                      backgroundColor: sortBy === 'date' && sortOrder === 'desc' ? '#e3f2fd' : 'transparent',
                      color: '#333',
                      cursor: 'pointer',
                      fontSize: '12px',
                      textAlign: 'left',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      borderBottom: '1px solid #f0f0f0'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = sortBy === 'date' && sortOrder === 'desc' ? '#e3f2fd' : '#f5f5f5'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = sortBy === 'date' && sortOrder === 'desc' ? '#e3f2fd' : 'transparent'}
                  >
                    <FiArrowDown size={12} />
                    Neueste zuerst
                  </button>
                  
                  <button
                    onClick={() => {
                      setSortBy('date');
                      setSortOrder('asc');
                      setShowSortDropdown(false);
                    }}
                    style={{
                      width: '100%',
                      padding: '8px 12px',
                      border: 'none',
                      backgroundColor: sortBy === 'date' && sortOrder === 'asc' ? '#e3f2fd' : 'transparent',
                      color: '#333',
                      cursor: 'pointer',
                      fontSize: '12px',
                      textAlign: 'left',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px'
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = sortBy === 'date' && sortOrder === 'asc' ? '#e3f2fd' : '#f5f5f5'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = sortBy === 'date' && sortOrder === 'asc' ? '#e3f2fd' : 'transparent'}
                  >
                    <FiArrowUp size={12} />
                    Älteste zuerst
                  </button>
                </div>
              )}
            </div>
          </div>
        </h4>
      )}
      
      {/* Toolbar für Tab-Ansicht */}
      {isInTab && (
        <div style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          padding: '8px 0',
          marginBottom: '12px',
          borderBottom: '1px solid #eee'
        }}>
          {/* Sortier-Dropdown für Tab-Ansicht */}
          <div className="sort-dropdown-container" style={{ position: 'relative' }}>
            <button
              onClick={() => setShowSortDropdown(!showSortDropdown)}
              style={{
                background: 'none',
                border: '1px solid #ddd',
                borderRadius: '4px',
                color: '#666',
                cursor: 'pointer',
                padding: '6px 10px',
                display: 'flex',
                alignItems: 'center',
                fontSize: '12px',
                backgroundColor: showSortDropdown ? '#f5f5f5' : 'transparent',
                gap: '6px'
              }}
              title="Sortierung ändern"
            >
              <FiSliders size={12} />
              Sortieren
            </button>
            
            {showSortDropdown && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                backgroundColor: 'white',
                border: '1px solid #ddd',
                borderRadius: '4px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                zIndex: 10000,
                minWidth: '180px',
                marginTop: '2px'
              }}>
                <button
                  onClick={() => {
                    setSortBy('name');
                    setSortOrder('asc');
                    setShowSortDropdown(false);
                  }}
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: 'none',
                    backgroundColor: sortBy === 'name' && sortOrder === 'asc' ? '#e3f2fd' : 'transparent',
                    color: '#333',
                    cursor: 'pointer',
                    fontSize: '12px',
                    textAlign: 'left',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    borderBottom: '1px solid #f0f0f0'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = sortBy === 'name' && sortOrder === 'asc' ? '#e3f2fd' : '#f5f5f5'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = sortBy === 'name' && sortOrder === 'asc' ? '#e3f2fd' : 'transparent'}
                >
                  <FiArrowUp size={12} />
                  Name A → Z
                </button>
                
                <button
                  onClick={() => {
                    setSortBy('name');
                    setSortOrder('desc');
                    setShowSortDropdown(false);
                  }}
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: 'none',
                    backgroundColor: sortBy === 'name' && sortOrder === 'desc' ? '#e3f2fd' : 'transparent',
                    color: '#333',
                    cursor: 'pointer',
                    fontSize: '12px',
                    textAlign: 'left',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    borderBottom: '1px solid #f0f0f0'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = sortBy === 'name' && sortOrder === 'desc' ? '#e3f2fd' : '#f5f5f5'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = sortBy === 'name' && sortOrder === 'desc' ? '#e3f2fd' : 'transparent'}
                >
                  <FiArrowDown size={12} />
                  Name Z → A
                </button>
                
                <button
                  onClick={() => {
                    setSortBy('date');
                    setSortOrder('desc');
                    setShowSortDropdown(false);
                  }}
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: 'none',
                    backgroundColor: sortBy === 'date' && sortOrder === 'desc' ? '#e3f2fd' : 'transparent',
                    color: '#333',
                    cursor: 'pointer',
                    fontSize: '12px',
                    textAlign: 'left',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    borderBottom: '1px solid #f0f0f0'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = sortBy === 'date' && sortOrder === 'desc' ? '#e3f2fd' : '#f5f5f5'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = sortBy === 'date' && sortOrder === 'desc' ? '#e3f2fd' : 'transparent'}
                >
                  <FiArrowDown size={12} />
                  Neueste zuerst
                </button>
                
                <button
                  onClick={() => {
                    setSortBy('date');
                    setSortOrder('asc');
                    setShowSortDropdown(false);
                  }}
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    border: 'none',
                    backgroundColor: sortBy === 'date' && sortOrder === 'asc' ? '#e3f2fd' : 'transparent',
                    color: '#333',
                    cursor: 'pointer',
                    fontSize: '12px',
                    textAlign: 'left',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = sortBy === 'date' && sortOrder === 'asc' ? '#e3f2fd' : '#f5f5f5'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = sortBy === 'date' && sortOrder === 'asc' ? '#e3f2fd' : 'transparent'}
                >
                  <FiArrowUp size={12} />
                  Älteste zuerst
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      
      {loading && (
        <div style={{ 
          textAlign: 'center', 
          padding: '20px 0', 
          color: '#666',
          fontSize: '14px'
        }}>
          Lade veröffentlichte Pläne...
        </div>
      )}
      
      {error && (
        <div style={{ 
          textAlign: 'center', 
          padding: '20px 0', 
          color: '#f44336',
          fontSize: '14px'
        }}>
          Fehler: {error}
          <button
            onClick={refresh}
            style={{
              marginLeft: '8px',
              padding: '4px 8px',
              border: '1px solid #f44336',
              backgroundColor: 'white',
              color: '#f44336',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '12px'
            }}
          >
            Erneut versuchen
          </button>
        </div>
      )}
      
      {!loading && !error && publishedPlans.length === 0 && (
        <div style={{ 
          textAlign: 'center', 
          padding: '20px 0', 
          color: '#666',
          fontSize: '14px'
        }}>
          Keine veröffentlichten Pläne verfügbar.
        </div>
      )}
      
      {!loading && !error && publishedPlans.length > 0 && (
        <div style={{ 
          minHeight: isInTab ? '300px' : '300px', 
          maxHeight: isInTab ? '400px' : '300px', 
          overflowY: 'auto', 
          overflowX: 'visible', 
          position: 'relative' 
        }}>
          {sortedPlans.map(plan => {
            const planKey = `${plan.user_id}_${plan.base_name}`;
            const isExpanded = expandedPlans.has(planKey);
            const versions = planVersions[planKey] || [];
            const hasMultipleVersions = versions.length > 1 || plan.version > 1;
            const isLoadingVersions = loadingVersions.has(planKey);
            const isCurrentlyLoaded = currentLoadedPlanId === plan.id;
            const isOwnPlan = plan.user_id === user?.username;
            
            return (
              <div key={plan.id} style={{
                marginBottom: '8px',
                border: isCurrentlyLoaded ? '2px solid #2196f3' : isOwnPlan ? '1px solid #4caf50' : '1px solid #e0e0e0',
                borderRadius: '6px',
                backgroundColor: isOwnPlan ? '#f8fff8' : 'white',
                boxShadow: isCurrentlyLoaded ? '0 0 12px rgba(33, 150, 243, 0.4)' : isOwnPlan ? '0 1px 3px rgba(76, 175, 80, 0.2)' : 'none',
                animation: isCurrentlyLoaded ? 'planGlow 2s ease-in-out infinite' : 'none',
                position: 'relative',
                overflow: 'visible'
              }}>
                {/* Haupt-Plan */}
                <div style={{
                  padding: '8px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'flex-start'
                }}>
                  <div style={{ flex: 1 }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '6px',
                      marginBottom: '2px'
                    }}>
                      <div style={{
                        fontWeight: '500',
                        fontSize: '14px',
                        color: '#333',
                        cursor: 'pointer'
                      }}
                      onClick={() => onLoadFromDatabase(plan.id, true)} // true für published plans
                      title="Klicken zum Laden (wird zu privatem Plan)"
                      >
                        {plan.name}
                      </div>
                      {hasMultipleVersions && (
                        <button
                          onClick={() => togglePlanExpansion(planKey, plan.user_id, plan.base_name)}
                          style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            color: '#666',
                            padding: '2px',
                            display: 'flex',
                            alignItems: 'center'
                          }}
                          title={`${isExpanded ? 'Versionen ausblenden' : 'Versionen anzeigen'}`}
                        >
                          {isLoadingVersions ? (
                            <div style={{
                              width: '12px',
                              height: '12px',
                              border: '2px solid #ddd',
                              borderTop: '2px solid #666',
                              borderRadius: '50%',
                              animation: 'spin 1s linear infinite'
                            }} />
                          ) : isExpanded ? (
                            <FiChevronUp size={12} />
                          ) : (
                            <FiChevronDown size={12} />
                          )}
                        </button>
                      )}
                      <div style={{
                        fontSize: '11px',
                        color: '#999',
                        backgroundColor: '#f0f0f0',
                        padding: '2px 6px',
                        borderRadius: '10px'
                      }}>
                        v{plan.version}
                      </div>
                    </div>
                    
                    {/* Benutzer-ID anzeigen */}
                    <div style={{
                      fontSize: '11px',
                      color: plan.user_id === user?.username ? '#2196f3' : '#666',
                      marginBottom: '4px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                      fontWeight: plan.user_id === user?.username ? 'bold' : 'normal'
                    }}>
                      <FiUser size={10} />
                      {plan.user_id === user?.username ? `${plan.user_id} (Sie)` : plan.user_id}
                    </div>
                    
                    {/* Veröffentlichte Gruppen anzeigen */}
                    <div style={{
                      fontSize: '11px',
                      color: '#4caf50',
                      marginBottom: '4px',
                      backgroundColor: '#e8f5e8',
                      padding: '2px 6px',
                      borderRadius: '10px',
                      display: 'inline-block'
                    }}>
                      {plan.published_groups}
                    </div>
                    
                    {plan.description && (
                      <div style={{
                        fontSize: '12px',
                        color: '#666',
                        marginBottom: '4px'
                      }}>
                        {plan.description}
                      </div>
                    )}
                    <div style={{
                      fontSize: '11px',
                      color: '#999'
                    }}>
                      {new Date(plan.updated_at).toLocaleDateString('de-DE', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                      })}
                    </div>
                  </div>
                </div>
                
                {/* Erweiterte Versionen */}
                {isExpanded && versions.length > 0 && (
                  <div style={{
                    borderTop: '1px solid #f0f0f0',
                    backgroundColor: '#fafafa',
                  }}>
                    {versions.map(version => {
                      const isVersionLoaded = currentLoadedPlanId === version.id;
                      return (
                        <div key={version.id} style={{
                          padding: '6px 16px',
                          borderBottom: version.id === versions[versions.length - 1].id ? 'none' : '1px solid #f0f0f0',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          backgroundColor: isVersionLoaded ? 'rgba(33, 150, 243, 0.05)' : 'transparent',
                          borderLeft: isVersionLoaded ? '3px solid #2196f3' : 'none',
                          marginLeft: isVersionLoaded ? '-3px' : '0'
                        }}>
                          <div style={{ flex: 1 }}>
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px',
                              cursor: 'pointer'
                            }}
                            onClick={() => onLoadFromDatabase(version.id, true)} // true für published plans
                            title="Klicken zum Laden (wird zu privatem Plan)"
                            >
                              <div style={{
                                fontSize: '12px',
                                color: version.id === plan.id ? '#4caf50' : '#666',
                                fontWeight: version.id === plan.id ? '500' : 'normal'
                              }}>
                                Version {version.version}
                                {version.id === plan.id && ' (aktuell)'}
                              </div>
                            </div>
                            <div style={{
                              fontSize: '10px',
                              color: '#999'
                            }}>
                              {new Date(version.updated_at).toLocaleDateString('de-DE', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit'
                              })}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default VeroeffentlichtePlaene;